<template>
  <v-row class="py-3">
    <v-col cols="5" sm="4" xl="3">
      <v-skeleton-loader
        max-width="60"
        height="12"
        type="text"
        class="rounded-lg"
      />
    </v-col>

    <v-col cols="7" sm="8" xl="9">
      <v-skeleton-loader max-width="100" height="12" type="text" class="ps-5" />
    </v-col>
  </v-row>
</template>

<script>
export default {};
</script>
